import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { createConnector, InferConnectedProps } from '../../redux/createConnector'
import { toggleNotes } from '../../redux/notes/actions'
import { logout, switchClient, updateAimProfile } from '../../redux/profile/actions'
import {
  clientInfo,
  isAdminLoggedAsClient,
  ownAimStatus,
  user,
} from '../../redux/profile/selectors'
import { title, titleCasing } from '../../redux/ui/selectors'
import MobileHeader, { IMobileHeaderProps } from './MobileHeader'

/**
 * Connected so MainLayout can render the mobile header directly.
 *
 * It used to live inside SideMenu and be fed by that component's props, which meant it
 * simply did not exist wherever the rail was not rendered — blank-layout routes, snapshot
 * mode, and due-diligence client users, whose SideMenu returns null.
 */
const selector = createStructuredSelector({
  user,
  clientInfo,
  isAdminLoggedAsClient,
  ownAimStatus,
  pageTitle: title,
  pageTitleCasing: titleCasing,
})

const actions = {
  onLogout: logout,
  toggleNotes,
  onSwitchClient: switchClient,
  updateAimProfile,
}

const connector = connect(selector, actions)

export type PropsFromRedux = InferConnectedProps<typeof connector, typeof actions>

export default createConnector<typeof connector, IMobileHeaderProps, PropsFromRedux>(
  connector,
  MobileHeader,
)
